import { action, payload } from 'ts-action'
import { IPostShiftFormValues } from '@src/features/shift-post-v2/pages/post-shift/post-shift.form'
import { IError, IPayload } from '@network/models/global.model'
import { IRoster, IRosterInviteHistory } from '@network/models/roster.model'
import { TShiftEditValues } from '@src/features/shift-post-v2/pages/edit-shift/edit-shift.types'
import { SHIFT_STATUS } from '@network/models/shift.model'
import { IShiftAutoAcceptCertificate } from '@network/models/shift-auto-accept-certificate.model'
import {
  IConfirmStepPayload,
  IShiftDetailsStepData,
  IAcceptanceCriteriaStepData,
  IScreeningRequirementsStepData,
  IInviteUpshiftersStepData,
  IConfirmStepData,
} from './shift-post-v2.types'

// Step data update actions
export const UpdateShiftDetailsData = action(
  'UpdateShiftDetailsData',
  payload<Partial<IShiftDetailsStepData>>(),
)

export const UpdateAcceptanceCriteriaData = action(
  'UpdateAcceptanceCriteriaData',
  payload<Partial<IAcceptanceCriteriaStepData>>(),
)

export const UpdateScreeningRequirementsData = action(
  'UpdateScreeningRequirementsData',
  payload<Partial<IScreeningRequirementsStepData>>(),
)

export const UpdateInviteUpshiftersData = action(
  'UpdateInviteUpshiftersData',
  payload<Partial<IInviteUpshiftersStepData>>(),
)

export const UpdateConfirmData = action(
  'UpdateConfirmData',
  payload<Partial<IConfirmStepData>>(),
)

// Step confirmation actions
export const ConfirmStep = action('ConfirmStep', payload<IConfirmStepPayload>())

// State management actions
export const ResetShiftPostV2 = action('ResetShiftPostV2')

export const SetShiftPostV2Loading = action(
  'SetShiftPostV2Loading',
  payload<boolean>(),
)

export const SetShiftPostV2Error = action(
  'SetShiftPostV2Error',
  payload<string | null>(),
)

// Submit action
export const SubmitShiftPost = action('SubmitShiftPost')

// Set initial values
export const SetShiftPostV2InitialValues = action(
  'SetShiftPostV2InitialValues',
  payload<IPostShiftFormValues>(),
)

export const SetShiftPostV2CopyEditInitialValues = action(
  'SetShiftPostV2CopyEditInitialValues',
  payload<TShiftEditValues | IPostShiftFormValues>(),
)

export const AddBadgesToEditInitialValues = action(
  'AddBadgesToEditInitialValues',
  payload<IShiftAutoAcceptCertificate[]>(),
)

export const AddAutoAcceptCertificateIdsToEditInitialValues = action(
  'AddAutoAcceptCertificateIdsToEditInitialValues',
  payload<number[]>(),
)

export const SetShiftPostV2CopyEditStatusForRequest = action(
  'SetShiftPostV2CopyEditStatusForRequest',
  payload<SHIFT_STATUS>(),
)

export const RostersFetching = action('RostersFetching', payload<boolean>())

export const GetRosters = action('GetRosters', payload<IPayload<IRoster[]>>())

export const GetRostersErrors = action('GetRostersErrors', payload<IError>())

export const MoveRoster = action(
  'MoveRoster',
  payload<{
    id: number
    direction: 'up' | 'down'
  }>(),
)

export const ReorderRosters = action(
  'ReorderRosters',
  payload<{
    oldIndex: number
    newIndex: number
  }>(),
)

export const ReorderRostersByInitialIds = action(
  'ReorderRostersByInitialIds',
  payload<{
    rosterIds: number[]
  }>(),
)

export const GetInvitesHistory = action(
  'GetInvitesHistory',
  payload<IPayload<IRosterInviteHistory[]>>(),
)

export const GetInvitesHistoryErrors = action(
  'GetInvitesHistoryErrors',
  payload<IError>(),
)

export const InvitesHistoryFetching = action(
  'InvitesHistoryFetching',
  payload<boolean>(),
)
